import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  width: 100%;
  margin: 0 -12px;
`

export const Lc = styled.div`
  width: 234px;
  padding: 0 12px;
`

export const Rc = styled.div`
  width: calc(100% - 234px);
  padding: 0 12px;
`
